import { render, staticRenderFns } from "./BYCQuestion.vue?vue&type=template&id=0ed94a51&scoped=true&"
import script from "./BYCQuestion.vue?vue&type=script&lang=js&"
export * from "./BYCQuestion.vue?vue&type=script&lang=js&"
import style0 from "./BYCQuestion.vue?vue&type=style&index=0&id=0ed94a51&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed94a51",
  null
  
)

export default component.exports